<template>
  <div :style="styles" class="hr-pie-icon">
    <div
      :class="`stage-${stage}`"
      :style="stylesPie"
      class="hr-pie-icon__pie"
    ></div>
  </div>
</template>

<script>
import { computed } from 'vue';
const stages = [0, 1, 2, 3, 4];

export default {
  name: 'hr-pie-icon',
  props: {
    stage: {
      type: Number,
      validator: val => stages.includes(val),
      default: 0,
    },
    size: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const styles = computed(
      () => `width: ${props.size}px; height: ${props.size}px;`
    );
    const stylesPie = computed(
      () => `border-width: ${props.size}px; border-radius: ${props.size}px;`
    );
    return {
      styles,
      stylesPie,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/core/style-vars.scss';

.hr-pie-icon {
  width: 19px;
  height: 19px;
  border-radius: 100%;
  border: 2px solid var(--co-text-primary);
  background: $co-text-contrast;
  margin: auto;
  position: relative;
  overflow: hidden;
}

.hr-pie-icon__pie {
  position: absolute;
  right: -2px;
  top: -2px;
  width: 0;
  height: 0;
  border-right: 10px solid $co-text-contrast;
  border-top: 10px solid $co-text-contrast;
  border-left: 10px solid $co-text-contrast;
  border-bottom: 10px solid $co-text-contrast;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  transform: rotate(45deg);
}

.hr-pie-icon__pie.stage-1 {
  border-top: 10px solid var(--co-text-primary);
}

.hr-pie-icon__pie.stage-2 {
  border-top: 10px solid var(--co-text-primary);
  border-right: 10px solid var(--co-text-primary);
}

.hr-pie-icon__pie.stage-3 {
  border-top: 10px solid var(--co-text-primary);
  border-right: 10px solid var(--co-text-primary);
  border-bottom: 10px solid var(--co-text-primary);
}

.hr-pie-icon__pie.stage-4 {
  border-top: 10px solid var(--co-text-primary);
  border-right: 10px solid var(--co-text-primary);
  border-left: 10px solid var(--co-text-primary);
  border-bottom: 10px solid var(--co-text-primary);
}
</style>
